@if(packages()?.initialPlannedSteps > 0){
<div class="flex-layout">
	<div class="flex-centered" data-cy="treatment-packages">
		<h2>{{'Treatment packages' | translate}}</h2>
		<ng-container [ngTemplateOutlet]="packagesContainer" [ngTemplateOutletContext]="{ type: FunctionALPackageType.PLANNED }"></ng-container>
	</div>

	@if(hasRefinementPackages()){
		<div class="flex-centered" data-cy="refinement-packages">
			<h2>{{'Refinements' | translate}}</h2>
			<ng-container [ngTemplateOutlet]="packagesContainer" [ngTemplateOutletContext]="{ type: FunctionALPackageType.REFINEMENT }"></ng-container>
		</div>
	}
	@if(hasChargeableRefinementPackages()){
		<div class="flex-centered" data-cy="chargeable-refinement-packages">
			<h2>{{'Chargeable refinements' | translate}}</h2>
			<ng-container [ngTemplateOutlet]="packagesContainer" [ngTemplateOutletContext]="{ type: FunctionALPackageType.CHARGEABLE_REFINEMENT }"></ng-container>
		</div>
	}
	@if(packages().plannedRefinementAligners !== undefined){
		<div class="flex-centered" data-cy="pending-refinement-packages">
			<h2>{{'Pending' | translate}}</h2>
			<div class="package"
				matTooltip="{{(isRefinementPackagePlanned() ? 'ReleasePending' : 'PlanningPending') | translate}}"
				matTooltipPosition="below"
			>
				{{"Package" | translate}} {{packages().closed.length + 1}} ({{ isRefinementPackagePlanned() ? packages().plannedRefinementAligners : '?'}})
			</div>
		</div>
	}
</div>
}
<ng-template #packagesContainer let-type="type">
	<div class="packages-container">
		<!-- Closed packages -->
		@for (closed_package of packages().closed; track $index) {
			@if(closed_package.type === type){
				<div class="package delivered">
					{{"Package" | translate}} {{ $index + 1 }} ({{ closed_package.steps }})
				</div>
			}
		}
		<!-- Active packages -->
		@if(packages().active && packages().active.type === type){
			<div class="package active">
				{{"Package" | translate}} {{packages().closed.length + 1}} ({{ packages().active.steps }})
			</div>
		}
		<!-- Pending packages -->
		@for (pending_package of packages().pending; track $index) {
			@if(pending_package.type === type){
				@if(pending_package.steps > 0){
					<div class="package">
						{{"Package" | translate}} {{$index + 1 + packages().closed.length +
					( packages().active ? 1: 0)}} ({{ pending_package.steps }})
				</div>
				}
			}
		}
	</div>
</ng-template>
